import { useEffect } from "react";
import { REDO, UNDO } from "./useCanvasReducer";

export default ({
  isEditing, //
  cards,
  zoom,
  deleteSelectedCards,
  changeZoom,
  selectedCardIds,
  selectAllCards,
  setDebug,
  debug,
  scrollToCenter,
  dispatch,
}) => {
  /**
   * Detect keys for various commands
   */
  useEffect(() => {
    function commands(e) {

      if (isEditing) {
        // guard against deleting when user is editing a text field
        return;
      }

      const meta = e.metaKey || e.ctrlKey;
      const shift = e.shiftKey;

      if (e.key === "Backspace" || e.key === "Delete") {
        deleteSelectedCards();
        e.preventDefault();
        return;
      }
      if (["z", "Z"].includes(e.key) && meta && shift) {
        dispatch({ type: REDO });
        e.preventDefault();
        return;
      }
      if (e.key === "z" && meta) {
        dispatch({ type: UNDO });
        e.preventDefault();
        return;
      }
      if (e.key === "0" && meta) {
        changeZoom(1);
        e.preventDefault();
        return;
      }
      if (e.key === "=" && meta) {
        changeZoom(zoom + 0.25);
        e.preventDefault();
        return;
      }
      if (e.key === "-" && meta) {
        changeZoom(zoom - 0.25);
        e.preventDefault();
        return;
      }
      if (e.key === "a" && meta) {
        selectAllCards();
        e.preventDefault();
        return;
      }
      if (e.key === "d" && meta) {
        e.preventDefault();
        setDebug(!debug);
      }
      if (e.key === "\\" && meta) {
        e.preventDefault();
        scrollToCenter();
      }
    }

    document.addEventListener("keydown", commands);

    return () => {
      document.removeEventListener("keydown", commands);
    };
  }, [cards, isEditing, zoom, selectedCardIds, debug]);
};
